import React, { useState, useEffect, useRef, useContext } from 'react';
import Stripe from './Stripe.js';
import useNetwork from '../useNetwork';
import { AppDataContext } from "./AppDataContext";
import CurrencyFormat from 'react-currency-format';
import { Loader } from './Loader';
import { captchaKey } from '../helpers';

export default function LoginAndRegistration(props) {
    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest } = useNetwork(false);

    // Login input fields
    const [userName, setUserName] = useState("");

    const [password, setPassword] = useState("");
    const [keepLoggedIn, setKeepLoggedIn] = useState(false);

    const updateUsernameValue = (evt) => { setUserName(evt.target.value) };
    const updatePasswordValue = (evt) => { setPassword(evt.target.value); };
    const keepLoggedInChecked = (evt) => { setKeepLoggedIn(evt.target.checked); };

    // Account input fields
    const [email, setEmail] = useState('');
    // handle any changes to the props.initialUserName
    useEffect(() => {
        if (props.initialUserName || props.initialUserName === '')
            setEmail(props.initialUserName);
    }, [props.initialUserName])

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [newAccountSubscribe, setNewAccountSubscribe] = useState(true);
    const [newAccountTerms, setNewAccountTerms] = useState(false);

    const checkNewAccountTerms = (evt) => { setNewAccountTerms(evt.target.checked) };
    const checkNewAccountSubscribe = (evt) => { setNewAccountSubscribe(evt.target.checked) };
    const updateEmailValue = (evt) => { setEmail(evt.target.value) };
    const updateNewPasswordValue = (evt) => { setNewPassword(evt.target.value); };
    const updateConfirmPasswordValue = (evt) => { setConfirmPassword(evt.target.value); };
    const updateFirstNameValue = (evt) => { setFirstName(evt.target.value); };
    const updateLastNameValue = (evt) => { setLastName(evt.target.value); };

    // Personal Info input fields
    const [phoneNumber, setPhoneNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [taxExempt, setTaxExempt] = useState(false);

    const updatePhoneNumberValue = (evt) => { setPhoneNumber(evt.value) };
    const updateCompanyNameValue = (evt) => { setCompanyName(evt.target.value) };
    const updateAddress1Value = (evt) => { setAddress1(evt.target.value) };
    const updateAddress2Value = (evt) => { setAddress2(evt.target.value) };
    const updateCityValue = (evt) => { setCity(evt.target.value) };
    const updateStateValue = (evt) => { setState(evt.target.value) };
    const updateZipValue = (evt) => { setZip(evt.value) };
    const taxExemptChecked = (evt) => { setTaxExempt(evt.target.checked) };

    // Email Verification Code
    const [verificationCode, setVerificationCode] = useState('');
    const updateVerificationCodeValue = (evt) => { setVerificationCode(evt.target.value) };

    // this will toggle the class which shows field validation
    const [formWasValidated, setFormWasValidated] = useState(false);

    // error message at the top
    const [registrationMessage, setRegistrationMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    // this handles the enter key on the form
    const onSubmitLoginForm = async (event) => {
        event.preventDefault();
        await login();
    }
 
    const login = async () => {
        setFormWasValidated(true);
        setRegistrationMessage(null);
        const url = 'api/site/login';

        if (userName.trim() != '' && password.trim() != '') {
            // since the the fields are filled in, we can go back to not Was Validated state.  Clear this so that 
            // the field level error messages aren't set if we show empty fields at this point (e.g logout and re-open login dialog)
            setFormWasValidated(false);

            const postData = {
                email: userName.trim(),
                password: password.trim(),
                keepLoggedIn: keepLoggedIn,
            };

            const resp = await netRequest(url, postData);

            // always clear the password from the field regardless of the result of the login results
            setPassword("");

            if (resp.status != 200 || resp.data == null) {
                setRegistrationMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
            } else if (resp.data.status != "Success") {
                switch (resp.data.status) {
                    case "AccountLocked":
                        setRegistrationMessage("Your account has been locked out because of too many failed attempts.");
                        break;
                    case "Error":
                    case "DoesNotExist":
                    default:
                        setRegistrationMessage("That Username/Password combination does not exist.");
                        break;
                }
            } else {
                // clear the user on success.  that way, if they log out, when they try to log back in, it is not there
                setUserName("");

                context.loggedIn(resp.data);

                if (resp.data.emailVerified && props.registrationComplete)
                    props.registrationComplete(resp.data);
            }
        }
    }

    // creeate a new user account
    const onRegisterForm = async (event) => {
        event.preventDefault();

        window.grecaptcha.ready(function () {
            window.grecaptcha.execute(captchaKey(), { action: 'register' }).then(async function (token) {
                //console.log(token);
                await registerAccount(token);
            });
        })


    }
    const registerAccount = async (token) => {
        
        setFormWasValidated(true);
        setRegistrationMessage(null);

        if (newAccountTerms == false) {
            setRegistrationMessage("Please agree to the Terms and Conditions and Privacy Policy.");
            return;
        }
        if (email.trim() != '' && newPassword.trim() != ''
            && firstName.trim() != '' && lastName.trim() != '') {

            if (newPassword.trim() != confirmPassword.trim()) {
                setRegistrationMessage("Your password and its confirmation must match");
            } else {
                const url = 'api/site/savenewuseraccount';
                const postData = {
                    email: email.trim(),
                    password: newPassword.trim(),
                    firstName: firstName.trim(),
                    lastName: lastName.trim(),
                    captchaToken: token,
                    subscribeToMailingList: newAccountSubscribe
                };

                const resp = await netRequest(url, postData);

                if (resp.isError || resp.data == null) {
                    setRegistrationMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
                } else if (resp.data.status != "Success") {
                    switch (resp.data.status) {
                        case "AccountExists":
                            setRegistrationMessage("The email is already registered.  If you've forgotten your password, please use the Forgot Password link in the Login In window.");
                            break;
                        case "Error":
                        default:
                            setRegistrationMessage(resp.data.message);
                            break;
                    }
                } else {
                    // clear the input fields before continuing
                    setEmail('');
                    setNewPassword('');
                    setConfirmPassword('');
                    setFirstName('');
                    setLastName('');

                    context.loggedIn(resp.data);

                    setFormWasValidated(false);
                    setRegistrationMessage(null);
                }
            }
        }
    }

    // save personal info
    const onRegisterPersonalForm = async (event) => {
        event.preventDefault();
        await registerPersonal();
    }
    const registerPersonal = async () => {
        setFormWasValidated(true);
        setRegistrationMessage(null);
        const url = 'api/site/savenewuserprofile';

        if (phoneNumber.trim() != '' && address1.trim() != '' && city.trim() != '' &&
            state.trim() != '' && zip.trim() != '') {
            const postData = {
                phone: phoneNumber.trim(),
                companyName: companyName.trim(),
                address1: address1.trim(),
                address2: address2.trim(),
                city: city.trim(),
                state: state.trim(),
                zip: zip.trim(),
                taxExempt: taxExempt,
            };

            const resp = await netRequest(url, postData);

            if (resp.isError) {
                setRegistrationMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
            } else {
                // clear the input fields before continuing
                setPhoneNumber('');
                setCompanyName('');
                setAddress1('');
                setAddress2('');
                setCity('');
                setState('');
                setZip('');
                setTaxExempt(false);

                context.setHasProfile(true);

                setFormWasValidated(false);
                setRegistrationMessage(null);

            }
        }
    }


    // submit payment information
    const registerPayment = (result) => {
        if (result.isError) {
            setRegistrationMessage(result.errorMessage);
        } else {
            context.setPayment(result.data);

            setFormWasValidated(false);
            setRegistrationMessage(null);
        }
    }

    // confirm the email address with the code that was emailed to the user
    const verifyCode = async () => {
        setFormWasValidated(true);
        setRegistrationMessage(null);

        if (verificationCode.trim() != '') {
            const url = 'api/site/verifyemail/' + verificationCode;

            const resp = await netRequest(url);

            if (resp.status != 200 || resp.data == null) {
                setRegistrationMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
            } else if (resp.data.result == false) {
                setRegistrationMessage("That verification code does not exist.  Please check your email again.  If you copied the code into your browser, make sure the whole code is there");
            } else {
                // clear the input fields before continuing
                setVerificationCode('');
                // since all sign up panel conditions are met we need to hide the panel (otherwise it will fall through the conditions and show an empty div)
                setShowSignupPanel(false);

                context.setEmailVerified(true);

                setFormWasValidated(false);
                setRegistrationMessage(null);

                if (props.registrationComplete)
                    props.registrationComplete();
            }
        }
    }

    // confirm the email address with the code that was emailed to the user
    const resendVerify = async () => {
        setVerificationCode('');
        setFormWasValidated(false);
        setRegistrationMessage(null);

        const url = 'api/site/sendverificationemail';

        const resp = await netRequest(url, {});

        if (resp.isError) {
            setRegistrationMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
        } else {
            setRegistrationMessage("A new verification code has been sent to your email address.  Please check your email (and spam folder) and enter the code you received above");
        }
    }

    const [showSignupPanel, setShowSignupPanel] = useState(!props.showLogin);

    
    const signupClicked = async () => {
        setShowSignupPanel(true);
    }

    const [showForgotPassword, setShowForgotPassword] = useState(false);
    
    const onSubmitForgotPasswordForm = async (event) => {
        event.preventDefault();
        await forgotPassword();
    }

    const forgotPassword = async () => {
        setFormWasValidated(true);
        setRegistrationMessage(null);
        setSuccessMessage(null);
        const url = 'api/site/RequestPasswordReset';

        if (userName.trim() != '') {
            // since the the fields are filled in, we can go back to not Was Validated state.  Clear this so that 
            // the field level error messages aren't set if we show empty fields at this point (e.g logout and re-open login dialog)
            setFormWasValidated(false);

            const postData = {
                Param: userName.trim(),              
            };

            const resp = await netRequest(url, postData);

            // always clear the password from the field regardless of the result of the login results
            setPassword("");

            if (resp.status != 200 || resp.data == null) {
                setRegistrationMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
            } else if (resp.data.isError) {
                setRegistrationMessage(resp.data.message);

            } else {
                setSuccessMessage("Instructions on how to reset your password have been sent to your email address.");
            }
        }
    }


    const [showReadOnlyTerms, setShowReadOnlyTerms] = useState(props.showReadOnlyTerms);
    useEffect(() => {
        setShowReadOnlyTerms(props.showReadOnlyTerms);
    }, [props.showReadOnlyTerms]);

    const [pickupTermsAggreed, setPickupTermsAggreed] = useState(false);
    const [auctionTermsAggreed, setAuctionTermsAggreed] = useState(false);

    const checkPickupTerms = (event) => {
        setPickupTermsAggreed(!pickupTermsAggreed);
    }

    const checkAuctionTerms = (event) => {
        setAuctionTermsAggreed(!auctionTermsAggreed);
    }

     

    const requestApproval = async () => {
        setFormWasValidated(true);

        if (pickupTermsAggreed == false || auctionTermsAggreed == false)
            return;

        setRegistrationMessage(null);

        const url = 'api/site/requestApproval';
        const postData = {
            Param: props.auctionSession.auction.secureId,
        };

        const resp = await netRequest(url, postData);

        if (resp.status != 200 || resp.data == null) {
            setRegistrationMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
        } else {
            setFormWasValidated(false);
            setRegistrationMessage(null);

            context.setRegisteredAuction(props.auctionSession.auction.secureId, resp.data.result);

            if (props.onApproved)
                props.onApproved();
        }
    }

    return (
        <>
            <Loader loading={loading} />
            {registrationMessage != null && <div class="text-center alert alert-danger">{registrationMessage}</div>}
            {successMessage != null && <div class="text-center alert alert-success">{successMessage}</div>}
            {
                /*
                * if the context's emailVerified is set (meaning they are logged in and have completed all registration),
                * OR if we're just being asked to show the read only version of the terms, then we can skip the login/registration sections
                */
            }
            {((!context.emailVerified || !context.hasPayment || context.expiredDate < new Date()) && !props.showReadOnlyTerms) || showSignupPanel ?
                <>
                    {!context.isLoggedIn && !showSignupPanel && !showForgotPassword &&
                        <div class="row">
                            <div className={"col-12" + (props.showSignup ? " col-md-6 mb-3" : "")}>
                                <div class="d-inline-block h-100 p-3 border-1 border-primary border-solid">
                                    <form className={"row g-3 needs-validation " + (formWasValidated == true ? "was-validated" : "")} onSubmit={onSubmitLoginForm} >
                                        <div class="col-12">
                                                <label for="username" class="form-label w-100">Email</label>
                                                <input type="email" class="form-control" placeholder="Email" required
                                                    onChange={updateUsernameValue}
                                                    value={userName}
                                                    maxLength="100"
                                                    pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your email.
                                                </div>
                                        </div>
                                        <div class="col-12">
                                                <label for="password" class="form-label w-100">Password</label>
                                                <input type="password" class="form-control" placeholder="Password" required
                                                    onChange={updatePasswordValue}
                                                    value={password}
                                                    maxLength="30"
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your password.
                                                </div>
                                        </div>
                                        <div class="col-12">
                                            <button type="submit" class="btn btn-secondary btn-fill w-100" onClick={()=>{ setFormWasValidated(true); } }>Log In</button>
                                        </div>
                                        <div class="col-12 mb-3">
                                            <div class="form-check d-flex">
                                                <input class="d-inline-block form-check-input" type="checkbox" onChange={keepLoggedInChecked} id="keepLoggedIn" />
                                                <label class="form-check-label" for="keepLoggedIn">
                                                    Keep me logged in on this device (do not check on a public computer)
                                                </label>
                                            </div>
                                        </div>

                                    </form>
                                    <div class="col-12 text-center"><button class="btn btn-link" onClick={() => { setShowForgotPassword(true); setRegistrationMessage(null); }} title="Forgot your password">Forgot your password?</button>
                                        </div>
                                </div>
                            </div>
                            {props.showSignup &&
                                <div class="col-12 col-md-6">
                                    <div class="d-inline-block h-100 p-3 border-1 border-primary border-solid">
                                        <h2>Register</h2>
                                        <p>Click the button below to register a new account. </p>
                                        <div class="col-12 mb-3">
                                            <button type="button" class="btn btn-secondary btn-fill w-100" onClick={signupClicked}>Register</button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {!context.isLoggedIn && !showSignupPanel && showForgotPassword &&
                        <div class="row">
                            <div className={"col-12"}>
                                <div class=" h-100 p-3 border-1 border-primary border-solid">
                                    <form className={"row g-3 needs-validation " + (formWasValidated == true ? "was-validated" : "")} onSubmit={onSubmitForgotPasswordForm} >
                                        <div class="col-12">
                                            <label for="username" class="form-label w-100">Email</label>
                                            <input type="email" class="form-control" placeholder="Email" required
                                                onChange={updateUsernameValue}
                                                value={userName}
                                                maxLength="100"
                                                pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                                            />
                                            <div class="invalid-feedback">
                                                Please enter your email.
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <button type="submit" class="btn btn-secondary btn-fill w-100" onClick={() => { setFormWasValidated(true); }}>Submit</button>
                                        </div>
                                        <div class="col-12 text-center"><button class="btn btn-link" onClick={() => { setShowForgotPassword(false); setRegistrationMessage(null); setSuccessMessage(null); }} title="Login">Login</button>
                                        </div>


                                    </form>

                                </div>
                            </div>
                        </div>
                    }
                    {(showSignupPanel || (context.isLoggedIn && (!context.emailVerified || !context.hasPayment || context.expiredDate < new Date()))) &&
                        <>
                            <p class="text-center">Sign up to start treasure hunting.</p>
                            {!context.isLoggedIn ?
                                <>
                                    <div class="d-block my-3">
                                        <ul class="bid--steps mx-auto p-0">
                                            <li id="bid-step-1" data-step="step-1" data-prevstep="" data-nextstep="step-2" class="d-inline-block mx-3 text-center bid--steps__step current">1</li>
                                            <li id="bid-step-2" data-step="step-2" data-prevstep="step-1" data-nextstep="step-3" class="d-inline-block mx-3 text-center bid--steps__step">2</li>
                                            <li id="bid-step-3" data-step="step-3" data-prevstep="step-2" data-nextstep="" class="d-inline-block mx-3 text-center bid--steps__step">3</li>
                                        </ul>
                                        <h6 id="stepTitle" class="text-center">Account Information</h6>
                                    </div>
                                <form className={"row g-3 needs-validation  " + (formWasValidated == true && "was-validated")} onSubmit={onRegisterForm}>
                                        <div class="col-12">
                                                <label for="email" class="form-label w-100">Email</label>
                                            <input type="email" class="form-control" id="email" placeholder="Email" required maxLength="100"
                                                pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                                                    onChange={evt => updateEmailValue(evt)}
                                                    value={email}
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your email.
                                                </div>
                                        </div>
                                        <div class="col-6">
                                                <label for="firstName" class="form-label w-100">First Name</label>
                                                <input type="text" class="form-control" id="firstName" placeholder="First Name" required maxLength="50"
                                                    onChange={evt => updateFirstNameValue(evt)}
                                                    value={firstName}
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your first name.
                                                </div>
                                        </div>
                                        <div class="col-6">
                                                <label for="lastName" class="form-label w-100">Last Name</label>
                                                <input type="text" class="form-control" id="lastName" placeholder="Last Name" required maxLength="50"
                                                    onChange={evt => updateLastNameValue(evt)}
                                                    value={lastName}
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your last name.
                                                </div>
                                        </div>
                                        <div class="col-6">
                                                <label for="newPassword" class="form-label w-100">Password</label>
                                                <input type="password" class="form-control" id="newPassword" placeholder="Password" required maxLength="30"
                                                    onChange={evt => updateNewPasswordValue(evt)}
                                                value={newPassword}
                                                minLength="8"
                                                pattern="^(?=.*[A-Za-z])((?=.*\d)|(?=.*[@$!%*#?&]))[A-Za-z\d@$!%*#?&]{8,}$"

                                                />
                                                <div class="invalid-feedback">
                                                    Please choose a password.
                                                </div>
                                        </div>
                                        <div class="col-6">
                                                <label for="confirmPassword" class="form-label w-100">Confirm Password</label>
                                                <input type="password" class="form-control" id="confirmPassword" placeholder="Confirm Password" required maxLength="30"
                                                    onChange={evt => updateConfirmPasswordValue(evt)}
                                                value={confirmPassword}

                                                minLength="8"
                                                pattern="^(?=.*[A-Za-z])((?=.*\d)|(?=.*[@$!%*#?&]))[A-Za-z\d@$!%*#?&]{8,}$"

                                                />
                                                <div class="invalid-feedback">
                                                    Please confirm your password.
                                                </div>
                                        </div>
                                        <ul class="col-12 login-validation mb-0">
                                            <li> 8 or more characters</li>
                                            <li> At least one number or special character</li>
                                        </ul>
                                    <div class="col-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="subscribeCheck"
                                                checked={newAccountSubscribe} onChange={checkNewAccountSubscribe} required
                                            />
                                            <label class="form-check-label" for="subscribeCheck">
                                                Notify me about new and closing auctions
                                                </label>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="termsCheck"
                                                checked={newAccountTerms} onChange={checkNewAccountTerms} required/>
                                            <label class="form-check-label" for="termsCheck">
                                                I have read and agree to the site's Terms and Conditions and Privacy Policy.
                                            </label>
                                        </div>
                                    </div>
                                        <div class="col-12 mb-3">
                                        <button type="submit" onClick={() => { setFormWasValidated(true); }} class="btn btn-secondary btn-fill w-100">Sign Up</button>
                                        <br />
                                        <div class="mt-2 text-center text-secondary"><small>This site is protected by reCAPTCHA and the Google <a target="_blank" href="https://policies.google.com/privacy">Privacy Policy</a> and <a target="_blank" href="https://policies.google.com/terms">Terms of Service</a> apply.</small></div>
                                        </div>
                                    {props.showBackToLogin !== false &&
                                        <div class="col-12 mb-3 text-center">
                                            <button type="button" onClick={() => setShowSignupPanel(false)} class="btn btn-primary btn-sm btn-link">
                                                <i class="fas fa-chevron-left"></i> Return to Login
                                            </button>
                                        </div>
                                    }

                                    </form>
                                </>
                            : !context.hasProfile ?
                                <>
                                    <div class="d-block my-3">
                                        <ul class="bid--steps mx-auto p-0">
                                            <li id="bid-step-1" data-step="step-1" data-prevstep="" data-nextstep="step-2" class="d-inline-block mx-3 text-center bid--steps__step ">1</li>
                                            <li id="bid-step-2" data-step="step-2" data-prevstep="step-1" data-nextstep="step-3" class="d-inline-block mx-3 text-center bid--steps__step current">2</li>
                                            <li id="bid-step-3" data-step="step-3" data-prevstep="step-2" data-nextstep="" class="d-inline-block mx-3 text-center bid--steps__step">3</li>
                                        </ul>
                                        <h6 id="stepTitle" class="text-center">Personal Information</h6>
                                    </div>
                                    <form className={"row g-3 needs-validation  " + (formWasValidated == true && "was-validated")} onSubmit={onRegisterPersonalForm}>
                                        <div class="col-12">
                                                <label for="phone" class="form-label w-100">Phone Number</label>

                                                <CurrencyFormat class="form-control" id="phone" placeholder="Phone Number" required value={phoneNumber}
                                                    onValueChange={evt => updatePhoneNumberValue(evt)} format="(###) ###-####" mask="_" type="tel"/>

                                                <div class="invalid-feedback">
                                                    Please enter your phone number.
                                                </div>
                                        </div>
                                        <div class="col-12">
                                            <label for="companyName" class="form-label w-100">Company Name (optional)</label>
                                            <input type="text" class="form-control" id="companyName" placeholder="Company Name" maxLength="60"
                                                onChange={evt => updateCompanyNameValue(evt)}
                                                value={companyName}
                                                />
                                        </div>
                                        <div class="col-12">
                                                <label for="address1" class="form-label w-100">Address 1</label>
                                                <input type="text" class="form-control" id="address1" placeholder="Address 1" required maxLength="60"
                                                    onChange={evt => updateAddress1Value(evt)}
                                                    value={address1}
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your address.
                                                </div>
                                        </div>
                                        <div class="col-12">
                                                <label for="address2" class="form-label w-100">Address 2</label>
                                                <input type="text" class="form-control" id="address2" placeholder="Address 2" maxLength="60"
                                                    onChange={evt => updateAddress2Value(evt)}
                                                    value={address2}
                                                />
                                        </div>
                                        <div class="col-5">
                                                <label for="city" class="form-label w-100">City</label>
                                                <input type="text" class="form-control" id="city" placeholder="City" required maxLength="30"
                                                    onChange={evt => updateCityValue(evt)}
                                                    value={city}
                                                />
                                            <div class="invalid-feedback">
                                                Please enter your city.
                                            </div>
                                        </div>
                                        <div class="col-3">
                                                <label for="state" class="form-label w-100">State</label>

                                                <select class="form-select" id="state" placeholder="State" required
                                                    onChange={evt => updateStateValue(evt)}
                                                    value={state}>
                                                    <option value=""> </option>
                                                    <option value="AL">Alabama</option>
                                                    <option value="AK">Alaska</option>
                                                    <option value="AZ">Arizona</option>
                                                    <option value="AR">Arkansas</option>
                                                    <option value="CA">California</option>
                                                    <option value="CO">Colorado</option>
                                                    <option value="CT">Connecticut</option>
                                                    <option value="DE">Delaware</option>
                                                    <option value="DC">District Of Columbia</option>
                                                    <option value="FL">Florida</option>
                                                    <option value="GA">Georgia</option>
                                                    <option value="HI">Hawaii</option>
                                                    <option value="ID">Idaho</option>
                                                    <option value="IL">Illinois</option>
                                                    <option value="IN">Indiana</option>
                                                    <option value="IA">Iowa</option>
                                                    <option value="KS">Kansas</option>
                                                    <option value="KY">Kentucky</option>
                                                    <option value="LA">Louisiana</option>
                                                    <option value="ME">Maine</option>
                                                    <option value="MD">Maryland</option>
                                                    <option value="MA">Massachusetts</option>
                                                    <option value="MI">Michigan</option>
                                                    <option value="MN">Minnesota</option>
                                                    <option value="MS">Mississippi</option>
                                                    <option value="MO">Missouri</option>
                                                    <option value="MT">Montana</option>
                                                    <option value="NE">Nebraska</option>
                                                    <option value="NV">Nevada</option>
                                                    <option value="NH">New Hampshire</option>
                                                    <option value="NJ">New Jersey</option>
                                                    <option value="NM">New Mexico</option>
                                                    <option value="NY">New York</option>
                                                    <option value="NC">North Carolina</option>
                                                    <option value="ND">North Dakota</option>
                                                    <option value="OH">Ohio</option>
                                                    <option value="OK">Oklahoma</option>
                                                    <option value="OR">Oregon</option>
                                                    <option value="PA">Pennsylvania</option>
                                                    <option value="RI">Rhode Island</option>
                                                    <option value="SC">South Carolina</option>
                                                    <option value="SD">South Dakota</option>
                                                    <option value="TN">Tennessee</option>
                                                    <option value="TX">Texas</option>
                                                    <option value="UT">Utah</option>
                                                    <option value="VT">Vermont</option>
                                                    <option value="VA">Virginia</option>
                                                    <option value="WA">Washington</option>
                                                    <option value="WV">West Virginia</option>
                                                    <option value="WI">Wisconsin</option>
                                                    <option value="WY">Wyoming</option>
                                                </select>
                                            <div class="invalid-feedback">
                                                Please enter your state.
                                            </div>
                                        </div>
                                        <div class="col-4">
                                                <label for="zip" class="form-label w-100">Zip Code</label>

                                                <CurrencyFormat class="form-control" id="zip" placeholder="Zip Code" required value={zip}
                                                    onValueChange={evt => updateZipValue(evt)} format="#####" />

                                                <div class="invalid-feedback">
                                                    Please enter your zip.
                                                </div>
                                        </div>
                                        <div class="col-12 px-3 form-check">
                                            <input class="form-check-input" type="checkbox" onChange={taxExemptChecked} id="ckTaxExempt" />
                                            <label class="form-check-label" for="ckTaxExempt">
                                                I am a tax-exempt reseller
                                            </label>
                                        </div>
                                        {taxExempt &&
                                            <p>
                                                In order to qualify for tax exempt status, you must upload an image of your tax certificate or supporting documentation in you Account/Tax Certificates page after you have completed registration.
                                            </p>
                                        }
                                        <div class="col-12 mb-3">
                                            <button type="submit" onClick={() => { setFormWasValidated(true); }}  class="btn btn-secondary btn-fill w-100">Next</button>
                                        </div>

                                    </form>
                                </>
                            : (!context.hasPayment || context.expiredDate < new Date()) ?
                                <>
                                    <div class="d-block my-3">
                                        <ul class="bid--steps mx-auto p-0">
                                            <li id="bid-step-1" data-step="step-1" data-prevstep="" data-nextstep="step-2" class="d-inline-block mx-3 text-center bid--steps__step ">1</li>
                                            <li id="bid-step-2" data-step="step-2" data-prevstep="step-1" data-nextstep="step-3" class="d-inline-block mx-3 text-center bid--steps__step">2</li>
                                            <li id="bid-step-3" data-step="step-3" data-prevstep="step-2" data-nextstep="" class="d-inline-block mx-3 text-center bid--steps__step current">3</li>
                                        </ul>
                                        <h6 id="stepTitle" class="text-center">Payment Information</h6>
                                        {(context.hasPayment && context.expiredDate < new Date()) &&
                                            <p>Your credit card has expired.  Please enter a new credit card with a valid expiration date</p>
                                        }
                                    </div>

                                    <Stripe onSubmitResults={registerPayment} />
                                </>
                            : !context.emailVerified ?
                                <>
                                    <form className={"row g-3 needs-validation  " + (formWasValidated == true && "was-validated")} >
                                        <p>
                                            You must verify your email before you can place a bid.
                                            We have sent you a verification code to the email address associated with your account.
                                            Please check your email for the code, enter the code in the box below, and click Verify.
                                        </p>
                                        <div class="col-12">
                                                <label for="verificationCode" class="form-label w-100">Verification Code</label>
                                                <input type="text" class="form-control" id="cardnumber" placeholder="Verify Code" required maxLength="60"
                                                    onChange={evt => updateVerificationCodeValue(evt)}
                                                    value={verificationCode}
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your Verification Code.
                                                </div>
                                        </div>

                                        <div class="col-12 ">
                                            <button type="button" onClick={verifyCode} class="btn btn-secondary btn-fill w-100">Verify</button>
                                        </div>


                                        <div class="col-12 ">
                                            <button type="button" onClick={resendVerify} class="btn   btn-primary  w-100">Resend a Verify Code</button>
                                        </div>

                                    </form>
                                </>

                            :
                                <>
                                </>
                            }

                        </>
            
                    }
                </>
                :
                props.auctionSession ?
                <>
                    <form className={"row g-3 needs-validation  " + (formWasValidated == true && "was-validated")} >
                            <h2 class="mb-3">{props.auctionSession.title}</h2>

                        <div class="row">
                            <div class="col-12 col-md-6 pb-2">
                                <h4 class="text-left auction-grid-header">
                                    Auction / Pickup Terms
                                    <div class="divider my-2"></div>
                                </h4>
                                <div class="d-flex align-items-center pickup__content py-2">
                                    <div class="d-inline me-3">
                                        <i class="bi bi-calendar-event"></i>
                                    </div>
                                    <div class="d-inline">
                                        <h4 class="mb-0 pb-0" >Auction closing</h4>
                                            <h5 class="mb-0 pb-0">{props.auctionSession.closeTimeLocalStr}</h5>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center pickup__content py-2">
                                    <div class="d-inline me-3">
                                        <i class="bi bi-currency-exchange"></i>
                                    </div>
                                    <div class="d-inline">
                                        <h4 class="mb-0 pb-0" >Buyer's Premium</h4>
                                            <h5 class="mb-0 pb-0">{props.auctionSession.auction.buyersPremiumStr}%</h5>
                                    </div>
                                </div>
                                    {props.auctionSession.auction.salesTaxStr &&
                                    <div class="d-flex align-items-center pickup__content py-2">
                                        <div class="d-inline me-3">
                                            <i class="bi bi-arrow-clockwise"></i>
                                        </div>
                                        <div class="d-inline">
                                            <h4 class="mb-0 pb-0" >Sales Tax</h4>
                                                <h5 class="mb-0 pb-0">{props.auctionSession.auction.salesTaxStr}%</h5>
                                        </div>
                                    </div>
                                }
                                <div class="d-flex align-items-center pickup__content py-2">
                                    <div class="d-inline me-3">
                                        <i class="bi bi-credit-card"></i>
                                    </div>
                                    <div class="d-inline">
                                        <h4 class="mb-0 pb-0" >Payments Accepted</h4>
                                        <h5 class="mb-0 pb-0">Cash, Cards</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 pb-2">
                                <h4 class="text-left auction-grid-header">
                                    Pickup Details
                                    <div class="divider my-2"></div>
                                </h4>
                                <div class="d-flex align-items-center pickup__content py-2">
                                    <div class="d-inline me-3">
                                        <i class="bi bi-pin-map"></i>
                                    </div>
                                    <div class="d-inline">
                                            <h4 class="mb-0 pb-0" >{props.auctionSession.auction.companyName}</h4>
                                            <h5 class="mb-0 pb-0">{props.auctionSession.auction.address1} {props.auctionSession.auction.city}, {props.auctionSession.auction.state}</h5>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center pickup__content py-2">
                                    <div class="d-inline me-3">
                                        <i class="bi bi-calendar-check"></i>
                                    </div>
                                    <div class="d-inline">
                                        <h4 class="mb-0 pb-0" >Pickup Times</h4>
                                            {props.auctionSession.auction.pickupWindowStrs.map((time, ix) => (
                                                <h5 key={"pw" + ix} class="mb-0 pb-0">{time}</h5>
                                        ))}
                                    </div>
                                </div>
                            </div>



                            <div class="col-12 pb-2">
                                <h4 class="text-left auction-grid-header">
                                    Pickup Terms
                                    <div class="divider my-2"></div>
                                </h4>
                                <div class="content-scroll mb-3">
                                        <div className="summernote-html" dangerouslySetInnerHTML={{ __html: props.auctionSession.auction.pickupTerms }}></div>
                                </div>
                                {!props.showReadOnlyTerms &&
                                    <div class="form-check">
                                        <input class="form-check-input" id="pickupTerms" type="checkbox" checked={pickupTermsAggreed} onChange={checkPickupTerms} required />
                                        <label class="form-check-label" for="pickupTerms">
                                            Agree with Pickup Terms
                                        </label>
                                    </div>
                                }
                            </div>

                                <div class="col-12 pb-5">
                                <h4 class="text-left auction-grid-header">
                                    Terms and Conditions
                                    <div class="divider my-2"></div>
                                </h4>
                                    <div class="content-scroll mb-3">
                                        <div className="summernote-html" dangerouslySetInnerHTML={{ __html: props.auctionSession.auction.termsAndConditions }}></div>
                                </div>
                                {!props.showReadOnlyTerms &&
                                    <div class="form-check">
                                        <input class="form-check-input" id="auctionTerms" type="checkbox" checked={auctionTermsAggreed} onChange={checkAuctionTerms} required />
                                        <label class="form-check-label" for="auctionTerms">
                                            Agree with Terms and Conditions
                                        </label>
                                    </div>
                                }
                            </div>


                        </div>

                        {!props.showReadOnlyTerms &&
                            <div class="text-center">
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" onClick={requestApproval} class="ms-2 btn btn-secondary btn-fill  ">Register for Auction</button>
                            </div>
                        }

                    </form>

                    </>
                    :
                    <></>
            }
        </>
    );

}